import { render, staticRenderFns } from "./MSignup.vue?vue&type=template&id=0a27ae72&scoped=true"
import script from "./MSignup.vue?vue&type=script&lang=js"
export * from "./MSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a27ae72",
  null
  
)

export default component.exports